import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { defineCustomElement as defineIonIcon } from 'ionicons/components/ion-icon.js';
import { defineCustomElement as defineIonSpinner } from '@ionic/core/components/ion-spinner.js';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// <ion-icon> (the app's ionicons build) and <ion-spinner> have always been defined eagerly at
// startup, because the @ionic/angular/standalone proxies (IonIcon via AddressInputComponent) sat in
// the initial bundle through SharedModule. Keep defining them before bootstrap so Ionic's lazy loader
// (which bundles its own ionicons version) does not take over these two elements.
defineIonIcon();
defineIonSpinner();

bootstrapApplication(AppComponent, appConfig).catch(err => console.log(err));

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window);
